import { useRef, useState } from "react";
import {
  declaredIncomeSchema,
  trackIncomeRejected,
  useSubmitIncome,
} from "@/features/scoring";
import { BotMessage } from "../../components/BotMessage";
import { TurnMessages } from "../../components/TurnMessages";
import { ChatComposer } from "../../components/ChatComposer";
import { ChatTurnLayout } from "../../components/ChatTurnLayout";
import { useTurnMessages } from "../../hooks/useTurnMessages";
import { chatCopy, formatIncome } from "../../engine/copy";
import type { ChatTurnProps } from "../../types/chat";

const MAX_INCOME_DIGITS = 7;

export function IncomeTurn({ isPromptTyped, onAnswered }: ChatTurnProps) {
  const { messages, addUser, addError } = useTurnMessages();
  const { submitIncome, isLoading } = useSubmitIncome({ onError: addError });
  const [income, setIncome] = useState("");
  const rejectedCount = useRef(0);

  const handleSend = async () => {
    const parsed = declaredIncomeSchema.safeParse(income);
    addUser(parsed.success ? formatIncome(parsed.data) : income);
    setIncome("");

    if (!parsed.success) {
      rejectedCount.current += 1;
      trackIncomeRejected(income, "chat", rejectedCount.current);
      addError(parsed.error.issues[0].message);
      return;
    }

    if (await submitIncome(parsed.data)) {
      onAnswered();
    }
  };

  return (
    <ChatTurnLayout
      messageCount={messages.length}
      thread={
        <>
          <BotMessage lines={chatCopy.income} isTyped={isPromptTyped} />
          <TurnMessages messages={messages} />
        </>
      }
      actions={
        <ChatComposer
          label="Venit lunar net (lei)"
          placeholder="Scrie venitul net, în lei"
          inputMode="numeric"
          autoComplete="off"
          enterKeyHint="send"
          maxLength={MAX_INCOME_DIGITS}
          value={income}
          onChange={(value) => setIncome(value.replace(/\D/g, ""))}
          onSubmit={() => void handleSend()}
          isLoading={isLoading}
        />
      }
    />
  );
}
